import join from './join'
import nombres from './nombres'
import apellidos from './apellidos'

const filters = {
  commaString: join,
  nombres,
  apellidos,
}

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    if (Object.keys(filters).length === 0) return

    Object.keys(filters).forEach(filter => {
      /* eslint-disable no-console */
      if (process.env.NODE_ENV === 'development') {
        console.log(`installed ${filter} filter globally`)
      }
      /* eslint-enable no-console */

      Vue.filter(filter, filters[filter])
    })

    Vue.prototype.$filters = Vue.options.filters
  },
}
